import React from 'react';
import { Toolbar, CardContent, List, Typography, ListItem, ListItemText } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import { parseDate } from './ConsentsTable';
import BasicField from '../../basic/BasicField';
import CollectionItemHeader from '../../layout/CollectionItemHeader';
import AppLoader from '../../basic/AppLoader';
import { useItem } from '../../../hooks/atoms/item-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';
import Invitation from './Invitation';

const ConsentsDetails = ({ id }) => {
  const {
    item: kit,
    itemIsLoading,
    itemError,
    refetch,
  } = useItem(CollectionKeys.REGISTRATION_KITS, id);

  if (itemIsLoading) {
    return <AppLoader />;
  }

  if (itemError) {
    return <p>Error</p>;
  }

  let addr = JSON.parse(kit.customer_id.address);
  if (null != addr) {
    addr = `${ addr.streetAddress }, ${ addr.city }, ${ addr.postalCode }`;
  } else {
    addr = '';
  }

  return (

    <>
      <CollectionItemHeader
        subtitle={ `Created at: ${ kit?.serial_number_id?.created_at }` }
      />
      <Toolbar />
      <Grid container spacing={ 3 }>
        <Grid container item xs={ 12 } spacing={ 3 }>
          <Grid item xs={ 4 }>
            <Card style={ { width: '50vw' } }>
              <CardContent>
                <Grid item xs={ 12 }>
                  <BasicField
                    title='Serial Number'
                    field={ kit.serial_number_id.serial }
                    disabled
                  />
                  <BasicField
                    title='Last Name'
                    field={ kit.customer_id.family_name }
                    disabled
                  />
                  <BasicField
                    title='First Name'
                    field={ kit.customer_id.name }
                    disabled
                  />
                  <BasicField
                    title='Registration done date'
                    field={ parseDate(kit?.metadata?.registrationDoneDate) }
                    disabled
                  />
                  <BasicField
                    title='Sample received date'
                    field={ parseDate(kit?.metadata?.sampleReceivedDate) }
                    disabled
                  />
                  <BasicField
                    title='Payment Status'
                    field={ kit?.metadata?.cashStatus }
                    disabled
                  />
                  <BasicField
                    title='Payment Amount'
                    field={ kit?.metadata?.cashAmount }
                    disabled
                  />
                  <BasicField
                    title='Invoice Number'
                    field={ kit?.metadata?.invoiceNumber }
                    disabled
                  />
                  <BasicField
                    title='Report creation'
                    field={ kit.serial_number_id?.metadata?.['Report creation'] }
                    disabled
                  />
                  <BasicField
                    title='Date of birth'
                    field={ kit.customer_id.birthdate ?? '' }
                    disabled
                  />
                  <BasicField
                    title='Biological Gender'
                    field={ kit.customer_id.gender }
                    disabled
                  />
                  <BasicField
                    title='Address'
                    field={ addr }
                    disabled
                  />
                  <BasicField
                    title='Email'
                    field={ kit.customer_id.email }
                    disabled
                  />
                  <BasicField
                    title='Mobile Number'
                    field={ kit.customer_id.phone_number }
                    disabled
                  />
                  <BasicField
                    title='Landline Number'
                    field={ kit.customer_id?.phoneNumber ?? '' }
                    disabled
                  />
                  {
                    null != kit.metadata && (
                      <BasicField
                        title='Sample collection date'
                        field={ parseDate(kit?.metadata?.sampleCollectionDate) }
                        disabled
                      />
                    )
                  }
                  <BasicField
                    title='Description'
                    field={ kit.serial_number_id?.metadata?.['Product Description'] }
                    disabled
                  />
                  <BasicField
                    title='Owner'
                    field={ kit.customer_id.email }
                    disabled
                  />
                  <BasicField
                    title='EMR'
                    field={ kit.serial_number_id?.metadata?.EMR }
                    disabled
                  />
                  <BasicField
                    title='Needs doctor consent'
                    field={ kit.serial_number_id?.metadata?.['Needs doctor consent'] }
                    disabled
                  />

                  {
                    0 !== kit.agreements.length && (
                      <Grid item xs={ 12 } md={ 6 }>
                        <Typography variant='h6'>
                          Agreements
                        </Typography>
                        <List>
                          {
                            kit.agreements.map((agreement) => {
                              return (
                                <ListItem key={ agreement.id }>
                                  <ListItemText
                                    disableTypography
                                    primary={ agreement.consent.name }
                                  />
                                </ListItem>
                              );
                            })

                          }

                        </List>
                      </Grid>
                    )
                  }
                  {
                    0 === kit.invitations.length && (
                      <Typography variant='h6'>
                        There are no doctor appointments.
                      </Typography>
                    )
                  }
                  {
                    0 !== kit.invitations.length && (
                      kit.invitations.filter((inv) => {
                        return true === inv.active;
                      }).map((inv) => {
                        return (
                          <Invitation refetch={ refetch } inv={ inv } key={ inv.id } />
                        );
                      })
                    )
                  }
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ConsentsDetails;
